{
  "users": {
    "label": "Utenti"
  },
  "userGroups": {
    "label": "Gruppi"
  },
  "userProfiles": {
    "label": "Profili"
  }
}
